export default {
  fieldset: 'form-group',
  buttonLabel: '',
  checkbox: '',
}



// WEBPACK FOOTER //
// src/common/form-elements/checkbox-element-folder/checkbox-element.style.js